'use strict';

define('vb/action/builtin/lockAction',[
  'vb/action/action',
],
(Action) => {
  /** @typedef {import('vb/action/action').Outcome} Outcome */

  /**
   * Launch the session lock as defined in the Security Provider implementation.
   * It invokes the handleLock function on the Security Provider.
   *
   * Returns a 'failure' outcome in case of error or the outcome 'success' if the session lock was successful.
   *
   * @extends Action
   * @category Action
   */
  class LockAction extends Action {
    /**
     * Performs the session lock action by invoking the handleLock function on the Security Provider.
     *
     * @async
     * @param {Object} [parameters] - Parameters for the action (currently unused).
     * @returns {Promise<Outcome>} The outcome of the session lock operation.
     * Returns a failure outcome if an error occurs or the Security Provider is missing.
     * Otherwise, returns a success outcome with a boolean payload indicating whether
     * the session lock was successful.
     * @throws {Error} If an error occurs during the session lock operation.
     */
    async perform(parameters) {
      const securityProvider = this.context.application.securityProvider;

      if (!securityProvider) {
        return Action.createFailureOutcome('Security Provider missing.');
      }

      try {
        const result = await securityProvider.handleLock();
        return Action.createSuccessOutcome(result);
      } catch (error) {
        return Action.createFailureOutcome('Error during the session lock operation', error);
      }
    }

    /**
     * Sets the context for the LockAction instance.
     *
     * @param {Object} context - The context object containing application-specific information.
     * @returns {void}
     */
    setContext(context) {
      this.context = context;
    }
  }

  return LockAction;
});

